/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import { fixData } from './jobs';

type IJob = [(store: any) => void, number];

const jobs: IJob[] = [
  [fixData, 300],
  // [uploadError, 10000],  FIXME: Cancel the reporting of Missing RecordData.
];

export const initCronjobs = (store: any) => {
  jobs.forEach((jobItem: IJob) => {
    const [job, delay] = jobItem;
    setInterval(() => job(store), delay);
  });
};
